import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { BreakpointObserver } from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root'
})
export class CoreMediaService {
  currentMediaQuery: string;
  onMediaUpdate: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(private _breakpointObserver: BreakpointObserver) {
    this.currentMediaQuery = '';
    this._init();
  }

  private _init(): void {
    const breakpoints = [
      '(max-width: 575.98px)',
      '(min-width: 576px) and (max-width: 767.98px)',
      '(min-width: 768px) and (max-width: 991.98px)',
      '(min-width: 992px) and (max-width: 1199.98px)',
      '(min-width: 1200px)'
    ];

    this._breakpointObserver.observe(breakpoints)
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(() => {
        let alias = 'bs-xl';
        if (this._breakpointObserver.isMatched('(max-width: 575.98px)')) alias = 'bs-xs';
        else if (this._breakpointObserver.isMatched('(min-width: 576px) and (max-width: 767.98px)')) alias = 'bs-sm';
        else if (this._breakpointObserver.isMatched('(min-width: 768px) and (max-width: 991.98px)')) alias = 'bs-md';
        else if (this._breakpointObserver.isMatched('(min-width: 992px) and (max-width: 1199.98px)')) alias = 'bs-lg';

        if (this.currentMediaQuery !== alias) {
          this.currentMediaQuery = alias;
          this.onMediaUpdate.next(alias);
        }
      });
  }
}